//import 'array-from-polyfill'
import 'airbnb-js-shims/target/es2015'
import React from 'react'
import bugsnag from 'bugsnag-js'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import AppContainer from './containers/AppContainer'
import configureStore from './store/configureStore'
import { Provider } from 'react-redux'
import createPlugin from 'bugsnag-react'
import { bugsnagClient } from './constants/AppConstants'
import { unregister } from './registerServiceWorker'
import './styles/App.css'

unregister()
// wrap your entire app tree in the ErrorTracker provided
const ErrorTracker = bugsnagClient.use(createPlugin(React))

ReactDOM.render(
  <ErrorTracker>
    <Provider store={configureStore}>
      <Router>
        <AppContainer />
      </Router>
    </Provider>
  </ErrorTracker>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept('./containers/AppContainer', () => {
    ReactDOM.render(
      <Provider store={configureStore}>
        <Router>
          <AppContainer />
        </Router>
      </Provider>,
      document.getElementById('root')
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js